class ComponentStickyBuyBoxCta extends HTMLElement {
  connectedCallback() {
    this.sectionEl = this.closest('.sticky-buy-box-cta-section') || this;
    this.targetVisibility = new Map();

    // Hidden until the observer decides otherwise; inert removes the CTA from tab order.
    this.setInert(true);

    const targets = document.querySelectorAll([
      '[id*="__product_buy_box"] form',
      '.landing-hero',
      '#shopify-section-footer',
    ].join(','));

    this.onResize = () => {
      if (this.sectionEl.classList.contains('is-visible')) {
        this.syncScrollPadding(true);
      }
    };
    window.addEventListener('resize', this.onResize);

    if (targets.length === 0) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.targetVisibility.set(entry.target, entry.isIntersecting);
        });

        const anyVisible = Array.from(this.targetVisibility.values()).some(Boolean);
        this.setVisible(!anyVisible);
      },
      { threshold: 0 }
    );

    targets.forEach((target) => this.observer.observe(target));
  }

  setInert(isInert) {
    this.sectionEl.inert = isInert;
    // Keep the host in sync when inert was set in initial markup.
    this.inert = isInert;
  }

  isPainted() {
    return getComputedStyle(this.sectionEl).display !== 'none';
  }

  syncScrollPadding(isVisible) {
    const root = document.documentElement;

    if (!isVisible || !this.isPainted()) {
      root.style.scrollPaddingBottom = '';
      return;
    }

    const height = Math.ceil(this.sectionEl.getBoundingClientRect().height);
    root.style.scrollPaddingBottom = height > 0 ? `${height}px` : '';
  }

  setVisible(isVisible) {
    this.sectionEl.classList.toggle('is-visible', isVisible);
    this.setInert(!isVisible);
    this.syncScrollPadding(isVisible);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    window.removeEventListener('resize', this.onResize);
    document.documentElement.style.scrollPaddingBottom = '';
  }
}

customElements.define('component-sticky-buy-box-cta', ComponentStickyBuyBoxCta);
